import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import AdminBusinessesView from './AdminBusinessesView';
import { getBusinessesRequest, updateBusinessStatusRequest } from '../../actions/index';

class AdminBusinessesContainer extends Component {
  static propTypes = {
    businesses: PropTypes.array,
    getAll: PropTypes.func.isRequired,
    loadingBusinesses: PropTypes.bool,
    loadingStatusUpdate: PropTypes.bool,
    updateStatus: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this.props.getAll();
  }

  onUpdateStatus = (id, status) => {
    this.props.updateStatus(id, status);
  };

  render() {
    const { businesses, loadingBusinesses, loadingStatusUpdate } = this.props;
    return (
      <AdminBusinessesView
        businesses={businesses}
        loadingBusinesses={loadingBusinesses}
        loadingStatusUpdate={loadingStatusUpdate}
        onUpdateStatus={this.onUpdateStatus}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    businesses: state.business.businesses,
    loadingBusinesses: state.business.loadingBusinesses,
    loadingStatusUpdate: state.business.loadingStatusUpdate,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getAll: () => dispatch(getBusinessesRequest()),
    updateStatus: (id, status) => dispatch(updateBusinessStatusRequest(id, status)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminBusinessesContainer);
